import { render } from "./AgentDetails.vue?vue&type=template&id=77fd697f&scoped=true&ts=true"
import script from "./AgentDetails.vue?vue&type=script&lang=ts"
export * from "./AgentDetails.vue?vue&type=script&lang=ts"

import "./AgentDetails.vue?vue&type=style&index=0&id=77fd697f&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fd697f"]])

export default __exports__